import type { ResourceScope } from '@obvio/server'

export const RESOURCE_PREFIXES: Partial<Record<ResourceScope, string>> = {
  page: '/',
}

export const PHONE_NUMBER = '+48 694 445 300'
